export default __webpack_public_path__ + "f4e912c0d4272c5cf6876c8426de9d63.svg";